import React from 'react';
import styled from 'styled-components';
import { AppBar, Container, Toolbar, useMediaQuery } from '@material-ui/core';
import { HeaderLogo } from '../HeaderLogo/HeaderLogo';
import { Navigation } from './Navigation';
import { headerStyles } from '../../pages/headerStyles';
import { MobileDrawer } from '../Drawer/MobileDrawer';

export const AppBarStyled = styled(AppBar)`
    background: #fff;
    border-bottom: none;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);
`;

export const HeaderAppBar = () => {
    const headerClasses = headerStyles();
    const mediaQuery = useMediaQuery('(min-width: 768px)');

    return (
        <AppBarStyled
            position="relative"
            color="default"
            elevation={0}
            className={headerClasses.appBar}
        >
            <Container>
                <Toolbar className={headerClasses.toolbar}>
                    <HeaderLogo />
                    {mediaQuery ? <Navigation /> : <MobileDrawer />}
                </Toolbar>
            </Container>
        </AppBarStyled>
    );
};
